export type SignupPersona = "SHIPPER" | "CARRIER" | "BROKER";

// Evotrux has no BROKER role: brokers quote on freight, so they belong on the
// carrier side. The persona is a signup-form distinction only.
export const PERSONA_TO_ROLE: Record<SignupPersona, RoleValue> = {
  SHIPPER: "SHIPPER",
  CARRIER: "CARRIER",
  BROKER: "CARRIER",
};

interface SignupPersonaOption {
  value: SignupPersona;
  label: string;
  // The carrier and broker copy is the wording company setup uses for the same
  // two choices, in CompanySetup/components/CompanyBusinessType/CarrierBusinessType.tsx.
  tooltip: string;
}

export const SIGNUP_PERSONA_OPTIONS: SignupPersonaOption[] = [
  {
    value: "SHIPPER",
    label: "Shipper",
    tooltip: "We have freight to move and we want carriers to quote on it.",
  },
  {
    value: "CARRIER",
    label: "Carrier",
    tooltip:
      "We own and operate our own fleet of trucks and drivers. We primarily handle freight transportation using our company assets.",
  },
  {
    value: "BROKER",
    label: "Broker",
    tooltip:
      "We coordinate freight transportation on behalf of shippers by partnering with outside carriers. We do not own or operate our own trucks.",
  },
];

export interface SignUpData {
  email: string;
  confirmEmail: string;
  password: string;
  firstName: string;
  lastName: string;
  workPhoneNumber: string;
  workPhoneNumberExtension: string;
  cellPhoneNumber: string;
  persona: SignupPersona | undefined;
  recaptchaToken: string | null;
}

// `persona` rides along for analytics only. It is absent on the invite signup
// routes, where the role comes from the invite rather than from the user.
export type SignupSubmissionData = Omit<
  SignUpData,
  "confirmEmail" | "persona"
> & {
  role: RoleValue;
  persona?: SignupPersona;
};

export type SignupPhoneField = "workPhoneNumber" | "cellPhoneNumber";

export type SignupPhoneErrors = Record<SignupPhoneField, string | null>;

export const EMPTY_SIGNUP_PHONE_ERRORS: SignupPhoneErrors = {
  workPhoneNumber: null,
  cellPhoneNumber: null,
};
